import { render, staticRenderFns } from "./JourneysTable.vue?vue&type=template&id=476a0531&scoped=true&"
import script from "./JourneysTable.vue?vue&type=script&lang=js&"
export * from "./JourneysTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476a0531",
  null
  
)

export default component.exports